__turbopack_context__.v({
  "bandCta": "services-page-module__g30KHq__bandCta",
  "body": "services-page-module__g30KHq__body",
  "card": "services-page-module__g30KHq__card",
  "check": "services-page-module__g30KHq__check",
  "desc": "services-page-module__g30KHq__desc",
  "grid": "services-page-module__g30KHq__grid",
  "image": "services-page-module__g30KHq__image",
  "item": "services-page-module__g30KHq__item",
  "list": "services-page-module__g30KHq__list",
  "media": "services-page-module__g30KHq__media",
  "num": "services-page-module__g30KHq__num",
  "outlinePulse": "services-page-module__g30KHq__outlinePulse",
  "serviceOutlinePulse": "services-page-module__g30KHq__serviceOutlinePulse",
  "title": "services-page-module__g30KHq__title",
});
